import { render, staticRenderFns } from "./drawer_addProduct.vue?vue&type=template&id=fb25a352&scoped=true&"
import script from "./drawer_addProduct.vue?vue&type=script&lang=js&"
export * from "./drawer_addProduct.vue?vue&type=script&lang=js&"
import style0 from "./drawer_addProduct.vue?vue&type=style&index=0&id=fb25a352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb25a352",
  null
  
)

export default component.exports